<template>
    <transition name="fade">
        <div class="toast" :class="{'show':isShow}">
            <p>{{msg}}</p>
        </div>
    </transition>
</template>
<script>
export default {
    data() {
        return {
            isShow:false
        }
    },
    props: {
        msg: {
            type: String,
            default: ''
        }
    },
    mounted() {
        setTimeout(()=>{
            this.isShow=true
        },0)
    },
    methods: {

    }
}
</script>
<style lang="scss" scoped>
.toast {
    position: fixed;
    z-index: 99;
    padding: 5px 12px;
    min-width: 180px;
    font-size: 14px;
    line-height: 35px;
    top: 180px;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    background: rgba(40, 40, 40, .85);
    text-align: center;
    white-space: nowrap;
    border-radius: 2px;
    color: #fff;
    opacity: 0;
    transition: opacity .5s;
}
.show{
    opacity: 1
}
.fade-enter-active,
.fade-leave-active {
    transition: opacity .5s;
}
.fade-enter,
.fade-leave-active {
    opacity: 0;
}
</style>



// WEBPACK FOOTER //
// index.vue?5c7120d1